import { useCallback, useContext } from "react";

import ProfileSnippet from "components/ProfileSnippet";
import { SwipperContext } from "components/Swipper";
import { useApi } from "hooks/useApi";
import { ApiEndpoint, baseFetcher } from "utils/baseFetcher";

export const suggestedIPUrl = () => {
  const url = new ApiEndpoint(`/api/v2/suggested-insight-providers`);
  url.searchParams.append("page[size]", "12");
  url.searchParams.append("include", "company");

  return url.href;
};

const DashboardPageSuggestedIP = () => {
  const { setEnabledSwipe } = useContext(SwipperContext);

  const { data: accounts, mutate } = useApi(suggestedIPUrl(), baseFetcher);

  const onFollow = useCallback(
    (profile) => {
      setTimeout(() => {
        mutate({
          ...accounts,
          data: accounts.data.map((a: any) => {
            if (profile.id === a.id) {
              return {
                ...a,
                isFollowed: profile?.isFollowed,
              };
            }

            return a;
          }),
        });
      }, 2000);
    },
    [accounts, mutate]
  );

  if (!accounts?.data?.length) return <></>;

  return (
    <div className="flex flex-col border-b-[1px] border-x-0 border-t-0 border-b-[#00000022] border-solid">
      <h1 className="text-base m-[15px]">Suggested Providers</h1>
      <div
        className="flex overflow-x-auto pb-[15px] px-[15px]"
        onScroll={() => {
          setEnabledSwipe?.(false);
        }}
      >
        {accounts?.data?.map?.((profile: any) => {
          if (profile.isFollowed) {
            return null;
          }

          return (
            <ProfileSnippet
              key={profile.id + profile.isFollowed}
              profile={profile}
              showFollowButton
              showCompany
              onFollow={onFollow}
              compactCard
            />
          );
        })}
      </div>
    </div>
  );
};

export default DashboardPageSuggestedIP;
